// @core/api/endpoints/subscription/set_subscription_pause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetSubscriptionPauseRequest,
  SubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Pause subscription
 * Temporarily pauses a subscription. Billing stops and access is suspended until resumed. Optional auto-resume date can be specified.
 */
export async function SetSubscriptionPause(
  subscription_id: string,
  data: SetSubscriptionPauseRequest,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/pause`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<SubscriptionResponse>(requestPath, data, requestOptions);
}
